<template>
    <div class="grid-container-index">
        
        <div class="grid-item-index">
            <analysis-filter 
                v-model="calls"
                @loading="loading = true"
                @done="loading = false"
            />
        </div>

        <div class="grid-item-index">
            <analysis-calls 
                :loading="loading"
                :value="calls"
                @processed="processCalls($event)"
                @loading="loading = true"
                @done="loading = false"
            />
        </div>

        <div class="grid-item-index">
            <analysis-queue v-if="hasControlRead" ref="queue" />
        </div>

    </div>    
</template>

<script>

import AnalysisFilter from './Filter.vue';
import AnalysisCalls from './Calls.vue';
import AnalysisQueue from './Queue.vue';

import api from '../api';

export default {
    name: 'analysis-selection',
    components: {
        AnalysisFilter,
        AnalysisCalls,
        AnalysisQueue
    },
    created() {
        const vm = this;

        api.validateControlPermission(api.permissionGrantType.read)
            .then( 
                () => vm.hasControlRead = true,
                () => vm.hasControlRead = false
            );
    },
    methods: {
        processCalls(processed) {
            const newCalls = this.calls.filter((call) => {
                return processed.indexOf(call.callId) === -1
            });

            this.calls = newCalls;
            this.$refs.queue.getQueue();
        }
    },
    data() {
        return {
            calls: [],
            loading: false,
            hasControlRead: false
        };
    }
};
</script>

<style lang="scss" scoped src="../Style/analysis-selection.scss">

</style>